import classes from './WorkQueuesHeader.module.css'
import ChangePageSimple from './noWorkq/ChangePageSimple'

export default function NoWorkQHeader() {
    return <div className={classes.controls_outer_container}>
        <ChangePageSimple />
    </div>
}